import { createItemListOnceHook } from 'modules/utils/helpers/createItemListOnceHook'
import actions from './duck'
import selectors from './selectors'

export const useFccOrderSkuList = createItemListOnceHook(selectors, actions.listRequested)
